import PropTypes from 'prop-types';
import { Box, LinearProgress, Typography } from '@material-ui/core';
import { alpha } from '@mui/material/styles';

/**
 * Barre de répartition d'une réponse dans une synthèse par question.
 *
 * Partagée par le tiroir de session (apprenants) et la synthèse transversale
 * des formateurs : mêmes proportions, mêmes couleurs, quel que soit le public.
 */
const AnswerBar = ({ label, count, total, accent, hint }) => {
  const pct = total > 0 ? (count / total) * 100 : 0;
  return (
    <Box sx={{ mb: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mb: 0.4 }}>
        <Typography sx={{ fontSize: '0.78rem', color: 'text.primary', fontWeight: 600, flexGrow: 1 }}>
          {label}
          {hint && (
            <Typography
              component="span"
              sx={{ fontSize: '0.66rem', color: 'text.disabled', fontWeight: 700, ml: 0.75 }}
            >
              {hint}
            </Typography>
          )}
        </Typography>
        <Typography sx={{ fontSize: '0.72rem', color: 'text.primary', fontWeight: 800 }}>
          {count}
        </Typography>
        <Typography sx={{ fontSize: '0.68rem', color: 'text.disabled', fontWeight: 700, minWidth: 38, textAlign: 'right' }}>
          {Math.round(pct)}%
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={pct}
        sx={{
          height: 6,
          borderRadius: 3,
          bgcolor: (theme) => alpha(theme.palette.text.disabled, 0.15),
          '& .MuiLinearProgress-bar': { bgcolor: accent, borderRadius: 3 }
        }}
      />
    </Box>
  );
};

AnswerBar.propTypes = {
  label: PropTypes.string,
  count: PropTypes.number,
  total: PropTypes.number,
  accent: PropTypes.string,
  /** Précision affichée en petit après le libellé (le poids de l'option). */
  hint: PropTypes.string
};

AnswerBar.defaultProps = {
  hint: null
};

export default AnswerBar;
